import apiClient from './ApiService';

// Separate transport: deferred revocation must not use the auth interceptor or analytics.
const base = String(import.meta.env.VITE_API_URL || '').replace(/\/$/, '');
async function request(path, input, token, signal) {
  const abort = new AbortController();
  const cancel = () => abort.abort();
  signal?.addEventListener('abort', cancel);
  if (signal?.aborted) cancel();
  const timer = setTimeout(cancel, 3000);
  try {
    const response = await fetch(`${base}/employee/devices/${path}`, {
      method: path === 'current' ? 'PUT' : 'POST', signal: abort.signal,
      credentials: 'omit',
      headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}`, 'X-Installation-Id': input.installation_id } : {}) },
      body: JSON.stringify(input),
    });
    if (!response.ok) {
      // Only the error code is kept: the body never reaches logs.
      const code = await response.json().then(body => (typeof body?.message === 'string' ? body.message : undefined), () => undefined);
      throw Object.assign(new Error('Device request failed'), { status: response.status, code });
    }
    return response.status === 204 ? undefined : await response.json();
  } finally { clearTimeout(timer); signal?.removeEventListener('abort', cancel); }
}
export const DeviceService = {
  list: async (installationId, signal) => {
    const response = await apiClient.get('employee/devices', {
      signal, headers: installationId ? { 'X-Installation-Id': installationId } : {},
    });
    return response.data;
  },
  register: (input, token, signal) => request('current', input, token, signal),
  disassociate: input => request('disassociate', input),
};
